import React, { ComponentProps, useCallback } from 'react';
import { MoviesContent, STAFF_SELECTION } from './MoviesContent';
import { isPrerender } from 'src/client/utils/prerenderDetect';
import { SORT_TYPES } from 'src/shared/constants/movies';
import { useSelector } from 'src/client/redux';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { SortDropdown } from '@tovia/man-ui';
import ConnectedViewOptions from '../ConnectedViewOptions';
import { setValue as setSettingsValue } from 'src/client/redux/modules/settings';
import { useDispatch } from 'react-redux';

type Props = {
  pageType: ComponentProps<typeof MoviesContent>['pageType'];
  basePageUrl: string;
  sortBySetting: string;
};

export const MoviesHeader = (props: Props) => {
  const { pageType, basePageUrl, sortBySetting } = props;
  const config = useSelector((state) => state.app.config);
  const menuOptions = SORT_TYPES.filter((type) => (type?.filter ? config[type.filter] : true));
  const history = useHistory();
  const dispatch = useDispatch();

  const changeSort = useCallback(
    (value: string | null) => {
      if (value) {
        const url = value === 'latest' ? `${basePageUrl}` : `${basePageUrl}/${value}`;
        history.push(url);
        dispatch(setSettingsValue('filmsSorting', value));
      }
    },
    [dispatch, history, basePageUrl],
  );

  if (isPrerender) {
    if (pageType === STAFF_SELECTION) return null;
    return (
      <div>
        Sort By:{' '}
        <div>
          {menuOptions.map((sortType) => {
            const link = `${basePageUrl}/${sortType.id}`;
            return (
              <Link key={sortType.id} to={link}>
                {' '}
                <FormattedMessage id={sortType.intlID} defaultMessage={sortType.title} />
              </Link>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="options">
      {pageType !== STAFF_SELECTION && (
        <SortDropdown menuOptions={menuOptions} value={sortBySetting} onChange={changeSort} />
      )}
      <ConnectedViewOptions />
    </div>
  );
};
